var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("\n                            " + _vm._s(_vm.id_logo != null ? 'Edit' : 'Tambah') + " Slider\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipe),
      expression: "data.tipe"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipe", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("[ Pilih Tipe ]")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Company Link")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Anak Perusahaan")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [(_vm.data.gambar != null) ? _c('img', {
    attrs: {
      "src": _vm.data.gambar,
      "width": "150px",
      "alt": "Foto"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "icon",
      "type": "file",
      "name": "icon"
    },
    on: {
      "change": function($event) {
        _vm.handleFile($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "id": "text1",
      "type": "text"
    },
    model: {
      value: (_vm.data.link),
      callback: function($$v) {
        _vm.$set(_vm.data, "link", $$v)
      },
      expression: "data.link"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "id": "text1",
      "type": "text"
    },
    model: {
      value: (_vm.data.description),
      callback: function($$v) {
        _vm.$set(_vm.data, "description", $$v)
      },
      expression: "data.description"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "id": "text1",
      "type": "text"
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [(_vm.id_logo != null) ? _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-warning waves-effect waves-button",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button"
    },
    on: {
      "click": _vm.update
    }
  }, [(!_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" Edit")]) : _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading")])]) : _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-primary waves-effect waves-button",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [(!_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]), _vm._v(" Simpan")]) : _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-danger waves-effect waves-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")]), _vm._v(" Batal")])])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header"
  }, [_c('h2', [_vm._v("Anak Perusahaan")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "text1"
    }
  }, [_vm._v("Tipe")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "icon"
    }
  }, [_vm._v("Gambar")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "text1"
    }
  }, [_vm._v("Link")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "text1"
    }
  }, [_vm._v("Description")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "text1"
    }
  }, [_vm._v("Name")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47cc3a1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/FormAnakPerusahaan.vue
// module id = sf5A
// module chunks = 1